import functionUncurryThis from './function-uncurry-this.mjs';
import arrayBufferByteLength$1 from './array-buffer-byte-length.mjs';

var uncurryThis = functionUncurryThis;
var arrayBufferByteLength = arrayBufferByteLength$1;

var slice = uncurryThis(ArrayBuffer.prototype.slice);

var arrayBufferIsDetached = function (O) {
  if (arrayBufferByteLength(O) !== 0) return false;
  try {
    slice(O, 0, 0);
    return false;
  } catch (error) {
    return true;
  }
};

export { arrayBufferIsDetached as default };
